class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.endDate = JSON.parse(this.dataset.deal).end_at * 1000;
    this.countDownElement = this.querySelector("#countdown-wrapper");
    this.updateCountdown();
    document.addEventListener('DOMContentLoaded', function() {
       this.atcBtn =
        this.countDownElement
          .closest("product-card")
          ?.querySelector("button.btn--atc") ||
        this.countDownElement
          .closest("div.current-deal-info-wrapper")
          ?.querySelector("button.btn--atc") ||
        this.countDownElement
          .closest("div.current-deal-info-wrapper")
          .querySelector("button.quick-add-btn") ||
        this.countDownElement
          .closest("div.product-info")
          .querySelector("button.btn--atc");
    });
    
    setInterval(() => this.updateCountdown(), 1000);
  }

  updateCountdown() {
    if (!this.endDate) return;
    const endDate = new Date(this.endDate).getTime();
    const now = new Date().getTime();
    const difference = endDate - now;

    if (difference <= 0) {
      this.countDownElement.textContent = `00:00:00:00`;
      return;
    }

    const days = Math.floor(difference / (1000 * 60 * 60 * 24))
      .toString()
      .padStart(2, "0");
    const hours = Math.floor(
      (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    )
      .toString()
      .padStart(2, "0");
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))
      .toString()
      .padStart(2, "0");
    const seconds = Math.floor((difference % (1000 * 60)) / 1000)
      .toString()
      .padStart(2, "0");

    this.countDownElement.textContent = `${days}:${hours}:${minutes}:${seconds}`;
    if (difference < 1000) {
      this.atcBtn.disabled = true;
    }
  }
}

if (!customElements.get("deal-countdown-timer")) {
  customElements.define("deal-countdown-timer", CountdownTimer);
}
